import React from 'react';

/**
 * One label-and-value line inside a breakdown panel.
 *
 * Pass `value` for the ordinary case (a span). Pass `children` instead when the
 * value is a composed node — a figure with a badge beside it, a hover text —
 * and the row renders it in place of the span.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.label - already translated by the caller
 * @param {React.ReactNode} [props.value]
 * @param {string} [props.className]
 * @param {string} [props.labelClassName]
 * @param {string} [props.valueClassName]
 * @param {React.ReactNode} [props.children] - replaces the value span
 */
export default function CgBreakdownRow({
  label,
  value,
  className = 'flex justify-between text-xs',
  labelClassName = 'text-gray-600',
  valueClassName = 'font-medium',
  children,
}) {
  return (
    <div className={className}>
      <span className={labelClassName}>{label}</span>
      {children === undefined ? <span className={valueClassName}>{value}</span> : children}
    </div>
  );
}
